import React from "react";
import moment from "moment";

function Timeline(props) {
  const { request_timeline, truck_array } = props.requestData;
  const { created_at } = truck_array[0];
  return (
    <>
      <div className="rounded-box mt-4">
        <div className="heading-wrapper black-bg text-center">
          <h6 className="text-white">Timeline</h6>
        </div>
        <div className="request-left-box p-3 p-sm-4">
          {request_timeline.map((timeline, i) => (
            <div key={i} className="row timeline-row">
              <div className="col-12">
                <div className="request-staus small-font-size">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="8"
                      cy="8"
                      r="8"
                      fill={i === 0 ? "#C4314B" : "#ECEBED"}
                    />
                  </svg>
                  {timeline.activity_title}
                </div>
              </div>
              <div className="col-12 caption light-grey-color pt-1 timeline-date">
                {moment(timeline.activity_datetime).format("LLL")}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Timeline;
